module.exports = __webpack_public_path__ + "media/footer/Facebook-a30be849.png";